export default __webpack_public_path__ + "66f0c981b610326dd6c8514261c20559.jpg";